import React from 'react';

interface ChatMessageListProps {
  messages: ChatMessage[];
  onRelatedClick?: (question: string, id: number) => void;
}

const ChatMessageList: React.FC<ChatMessageListProps> = ({ messages, onRelatedClick }) => {
  return (
    <div className="chatbot-message-list">
      {messages.length === 0 && (
        <div className="chatbot-message chatbot-message--bot chatbot-welcome">
          <p className="mb-0 text-muted">Ask a question and I’ll search the Knowledge Base for an answer.</p>
        </div>
      )}
      {messages.map((msg) => (
        <div key={msg.id} className={`chatbot-message chatbot-message--${msg.role}`}>
          <div className="chatbot-message-bubble">
            <div className="chatbot-message-content">{msg.content}</div>
            {msg.isFallback && (
              <div className="chatbot-fallback-note small text-muted mt-1">
                No exact match found. Try rephrasing or pick a related question below.
              </div>
            )}
            {msg.relatedQuestions && msg.relatedQuestions.length > 0 && (
              <div className="chatbot-related mt-2">
                <div className="small text-muted mb-1">Related questions:</div>
                <div className="d-flex flex-wrap gap-1">
                  {msg.relatedQuestions.map((r) => (
                    <button
                      key={r.id}
                      type="button"
                      className="btn btn-sm btn-outline-primary chatbot-related-btn"
                      onClick={() => onRelatedClick?.(r.question, r.id)}
                    >
                      {r.question}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChatMessageList;
